import styled from 'styled-components';
import CustomButton from '@/components/custom-button/custom-button';

export const WalletProfileContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    padding: 24px;
    width: 100%;
    max-width: 480px;
    margin: 0 auto;

    & > div:first-child {
        transform: scale(1.5);
        margin: 24px 0;

        button {
            transform: scale(0.7);
            bottom: -5%;
            right: -5%;
        }
    }
`;

export const UsernameText = styled.h2`
    color: ${({ theme }) => theme?.colors?.text?.headings};
    font-family: 'Red Hat Display', sans-serif;
    font-size: 24px;
    font-weight: 700;
    line-height: 120%;
    margin: 0;
    text-align: center;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`;

export const StyledConfigButton = styled(CustomButton)`
    color: ${({ theme }) => theme?.colors?.text?.paragraphs};
    background-color: green;
    
    &:hover {
        color: ${({ theme }) => theme?.colors?.theme?.brandColor3};
    }
`; 